// Query keys centralizadas y jerárquicas del dominio commission.
export const commissionKeys = {
  all: ["commission"] as const,
  payments: () => [...commissionKeys.all, "payments"] as const,
} as const;
